import { Link, TableCell, TableRow } from '@mui/material';
import React from 'react';

const TariffLineTableRow = ({
  id,
  lineName = '',
  lineType = '',
  lineRate = '',
  lineUnit = '',
  lineCategory = '',
  linePeriod = '',
  lineQuantity = '',
  lineBatches = '',
  onClickName = null,
  line = null,
}) => (
  <TableRow>
    <TableCell>
      <Link component="button" onClick={() => onClickName(line)}>
        {lineName}
      </Link>
    </TableCell>
    <TableCell>{lineType}</TableCell>
    <TableCell>{lineRate}</TableCell>
    <TableCell>{lineUnit}</TableCell>
    <TableCell>{lineCategory}</TableCell>
    <TableCell>{linePeriod}</TableCell>
    <TableCell>{lineQuantity}</TableCell>
    <TableCell>{lineBatches}</TableCell>
  </TableRow>
);

export default TariffLineTableRow;
